import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { PaginationWrapper } from './SortAndPagination.css.js';
import { defaultPageSize } from '../../../helpers';
import { PaginationElements } from './pagination_components';

const ITEMS_PER_PAGE = 60;
const ALLOWED_SKIP_BEFORE_REDIRECT = 29;

class Pagination extends Component {
  constructor(props) {
    super(props);
    this.handleOffsetClick = this.handleOffsetClick.bind(this);
  }

  handleOffsetClick(e) {
    const selectedPage = Number.parseInt(e.target.innerText, 10) - 1;
    const offset = selectedPage * defaultPageSize;
    if (offset > ITEMS_PER_PAGE * ALLOWED_SKIP_BEFORE_REDIRECT) {
      window.location.href = '/refine_your_search';
    }
    const { handleClick, paginationOffset } = this.props;
    if (offset.toString(10) === paginationOffset) {
      return;
    }
    handleClick(offset);
  }

  render() {
    const { align, totalProducts, paginationOffset } = this.props;
    return (
      <PaginationWrapper align={align}>
        <PaginationElements
          pageSize={defaultPageSize}
          totalProducts={totalProducts}
          handleClick={this.handleOffsetClick}
          paginationOffset={paginationOffset}
        />
      </PaginationWrapper>
    );
  }
}

Pagination.propTypes = {
  align: PropTypes.string,
  handleClick: PropTypes.func.isRequired,
  paginationOffset: PropTypes.number.isRequired,
  totalProducts: PropTypes.number.isRequired,
};

export default Pagination;
